import { FC, useState } from 'react';
import { FiExternalLink, FiPlus, FiUsers } from 'react-icons/fi';
import { Lead, PersonalLead } from 'models/Lead';
import { CreateLeadModal, LeadCard, StatusTabs } from './components';
import { BlockUI, Button, Pagination, SkeletonCard } from 'components';
import { PaginationInfo } from 'models/PaginatedData';
import { Modal } from 'ncoded-component-library';
import { LeadEditor } from 'pages/Lead/components';
import PersonalLeadCard from './components/PersonalLeadCard';

import './Leads.styles.scss';
import { isLeadPersonal } from 'utils/lead';

type LeadsProps = {
  leads: Lead[];
  pagination?: PaginationInfo;
  loading: boolean;
  campaignId: string;
  personal?: boolean;
};

const Leads: FC<LeadsProps> = (props) => {
  const { leads, pagination, loading, campaignId, personal } = props;

  const [previewModalOpen, setPreviewModalOpen] = useState(false);
  const [currentLead, setCurrentLead] = useState<Lead | PersonalLead>();
  const [createLeadModalOpen, setCreateLeadModalOpen] = useState(false);

  return (
    <div className="leads">
      <div className="leads__header">
        <div className="leads__title">
          <FiUsers />
          Leads
          <Button
            className="leads-header__create-btn"
            onClick={() => setCreateLeadModalOpen(true)}
          >
            <FiPlus /> Create
          </Button>
        </div>
        <StatusTabs />
      </div>

      <BlockUI
        loading={loading}
        loadingElement={
          <div className="leads__content">
            <SkeletonCard className="leads__skeleton-card" />
            <SkeletonCard className="leads__skeleton-card" />
            <SkeletonCard className="leads__skeleton-card" />
            <SkeletonCard className="leads__skeleton-card" />
            <SkeletonCard className="leads__skeleton-card" />
            <SkeletonCard className="leads__skeleton-card" />
          </div>
        }
      >
        <div className="leads__content">
          {pagination?.totalItems === 0 && 'No items found.'}
          {leads?.map((lead) =>
            personal ? (
              <PersonalLeadCard
                lead={lead}
                key={lead._id}
                onQuickPreview={(lead) => {
                  setCurrentLead(lead as PersonalLead);
                  setPreviewModalOpen(true);
                }}
              />
            ) : (
              <LeadCard
                lead={lead}
                key={lead._id}
                onQuickPreview={(lead) => {
                  setCurrentLead(lead);
                  setPreviewModalOpen(true);
                }}
              />
            ),
          )}
        </div>
        <Pagination pagination={pagination} />
      </BlockUI>
      {previewModalOpen && (
        <Modal
          open={previewModalOpen}
          onClose={() => setPreviewModalOpen(false)}
          title={
            <div>
              {!isLeadPersonal(currentLead) && <>Lead for </>}
              <a
                href={currentLead?.listingUrl || currentLead?.linkedin_url}
                target="_blank"
                rel="noopener noreferrer"
                className="active-link"
              >
                {currentLead?.jobTitle ||
                  `${currentLead?.first_name} ${currentLead?.last_name}`}{' '}
                <FiExternalLink />
              </a>
              <div className="company-name">
                Company:{' '}
                <span>
                  {currentLead?.companyName || currentLead?.company_name}
                </span>
              </div>
            </div>
          }
          className="leads__preview-modal"
        >
          <LeadEditor
            onSuccess={() => setPreviewModalOpen(false)}
            id={currentLead?._id}
            lead={currentLead}
            isPersonal={isLeadPersonal(currentLead)}
          />
        </Modal>
      )}
      {createLeadModalOpen && (
        <CreateLeadModal
          isOpen={createLeadModalOpen}
          onClose={() => setCreateLeadModalOpen(false)}
          campaignId={campaignId}
          isPersonal={personal}
        />
      )}
    </div>
  );
};

export default Leads;
